import { useNavigate } from "react-router-dom";
import { PageHeader } from "@/components/page-header";
import SiteSetup from "@/components/site-setup";

export default function SiteNew() {
  const navigate = useNavigate();

  const handleComplete = () => {
    // Site setup completed, redirect to dashboard
    navigate("/dashboard");
  };

  return (
    <>
      <PageHeader
        title="Add a new site"
        description="Let's set up your construction site"
      />
      <SiteSetup onComplete={handleComplete} />
    </>
  );
}
